import React from 'react';
import { MedicalDataTypes } from '../../../primary-record-types';
import { SearchInputRecord } from './ResourceListSearchFilters';
import useMedicalProfileResource from '../../../hooks/api/useMedicalProfileResource';

export const placeholderResource: SearchInputRecord = {
    dateAdded: new Date().toISOString(),
    id: 'placeholder',
    type: 'allergy',
    version: '1',
    name: 'placeholder',
    status: 'active',
    allergyType: null,
    notes: '',
    metadata: {
        source: '1uphealth',
        healthSystemId: null,
        ingestDateTime: new Date().toISOString(),
        fhirVersion: 'dstu2',
    } as any,
    groupingMetadata: {
        groupId: '1',
        isPrimary: true,
    },
};

export type LoadableResourceContainerOwnProps = {
    medicalProfileId: string;
    resourceId: string;
    resourceType: MedicalDataTypes.PrimaryRecordResourceCategory;
    render: (props: { isLoading: boolean; resource: SearchInputRecord | null }) => React.ReactNode;
};

export type LoadableResourceContainerProps = LoadableResourceContainerOwnProps;

const LoadableResourceContainer: React.FC<LoadableResourceContainerProps> = (props) => {
    const { isLoading, resourceGroup } = useMedicalProfileResource({
        medicalProfileId: props.medicalProfileId,
        resourceCategory: props.resourceType,
        resourceId: props.resourceId,
    });

    return <>{props.render({ isLoading, resource: resourceGroup || null })}</>;
};

export default React.memo(LoadableResourceContainer);
